import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import { StageContext } from '../../Context';
import Grid from 'Geodata/grid';
export interface OneToThreeStageParameters extends StageParameters {}

class OneToThreeStage extends FilterStage<OneToThreeStageParameters> {
    constructor() {
        super({});
    }

    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        const index = sensorData.getSensorPoint().index;
        const floor = sensorData.getSensorPoint().getFloor();

        // Update isActive:
        const xyzArray = Grid.indexToXYZ(index);
        const i = xyzArray[0];
        const j = xyzArray[1];
        return !(floor % 3 !== 1 || j % 3 !== 1 || i % 3 !== 1);
    }
}

export default OneToThreeStage;
